// extracted by mini-css-extract-plugin
export default {"noBorders":"styles_noBorders__odwy-","contained":"styles_contained__XKzKp"};